<div class="promoters__container" [hidden]="isCreatingNewPromoter">
  <h2>SELECCION DE SPONSORS</h2>

  <div fxLayout="row nowrap" fxLayoutGap="1rem" fxLayoutAlign="start center">
    <span fxLayout="20">Selecciona el/los sponsores para el sorteo</span>
    <button mat-button fxLayout="20" color="primary" class="uppercase" (click)="isCreatingNewPromoter = true">
      Agregar nuevo sponsor
    </button>
  </div>
  <div class="promoters__list">
    <div class="promoter__item" (click)="selectPromoter(promoter, $event.currentTarget)" matTooltip="{{ promoter.name }}" [ngClass]="" *ngFor="let promoter of promoters">
      <img src="{{ promoter.image }}" alt="{{ promoter.name }}" />
    </div>
  </div>
  <hr />
  <div class="d-flex justify-content-end">
    <button mat-button fxLayout="20" color="primary" (click)="addPromoters()">
      Guardar
    </button>
  </div>
</div>
<div class="new__promoter" [hidden]="!isCreatingNewPromoter">
  <div action="#" autocomplete="off" [formGroup]="newPromoterForm">
    <h2 class="font-weight-bold mb-4">AGREGAR PREMIO</h2>
    <div fxLayout="row nowrap" fxLayoutGap="2rem" fxLayoutAlign="start center">
      <span fxFlex="35">Imagen del premio/producto:</span>
      <img class="img-60" src="{{ newPromoterImgReview }}" alt="" />
      <button mat-stroked-button color="primary" (click)="uploadNewPromoterImg()">
        Agregar imagen
      </button>
      <input fxFlex (change)="handleFileInput($event.target.files[0])" id="fileInput" type="file" hidden />
      <mat-error *ngIf="newPromoterForm.get('image').hasError('required')">
        La imagen es requerida
      </mat-error>
    </div>
    <div class="mb-4" fxLayout="row nowrap" fxLayoutGap="2rem" fxLayoutAlign="start center">
      <span fxFlex="35">Nombre del producto:</span>
      <mat-form-field class="w-100">
        <input matInput fxflex #nameInput formControlName="name" />
        <mat-error *ngIf="newPromoterForm.get('name').hasError('required')">
          El nombre es requerido
        </mat-error>
      </mat-form-field>
    </div>
    <hr />
    <div class="d-flex justify-content-end">
      <button mat-button fxLayout="20" (click)="resetForm()">
        Cancelar
      </button>
      <button mat-button fxLayout="20" [disabled]="!newPromoterForm.valid" color="primary" (click)="saveNewPromoter()">
        Agregar
      </button>
    </div>
  </div>
</div>